import script from "./Preload.vue?vue&type=script&lang=js"
export * from "./Preload.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__